export const colors = {
  white: "var(--color--white)",
  neutral_050: "var(--color--neutral-050)",
  neutral_100: "var(--color--neutral-100)",
  neutral_200: "var(--color--neutral-200)",
  neutral_300: "var(--color--neutral-300)",
  neutral_400: "var(--color--neutral-400)",
  neutral_500: "var(--color--neutral-500)",
  neutral_600: "var(--color--neutral-600)",
  neutral_700: "var(--color--neutral-700)",
  neutral_800: "var(--color--neutral-800)",
  error: "var(--danger-color)",
  success: "var(--success-color)",
  link: "var(--link--color)",
  form_input_border_color: "var(--text-input--border-color)",
  warning: "var(--warning-color)",
  base_font: "var(--base-font-color)"
}
